import React from "react"
import {NewsLayout} from "sections/News/"
import useNewsData from "shared/Hooks/News/useNewsData"
import {TextBlock} from "src/sections/News/NewsLayout/TextBlock";
import {NEWS_29} from "types/News"
import {Images} from '../../sections/News/NewsLayout/Images';

const Article = () => {
  const data = useNewsData(NEWS_29);

  return (
    <NewsLayout data={data}>
      <TextBlock data={data.texts.first}/>
      <TextBlock data={data.texts.second}/>
      <TextBlock data={data.texts.third}/>
      <TextBlock data={data.texts.fourth}/>
      <TextBlock data={data.texts.fifth}/>
      <TextBlock data={data.texts.sixth}/>
      <TextBlock data={data.texts.seventh}/>
      <Images data={data.images.first}/>
    </NewsLayout>
  )
}

export default Article
